(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunshine-ai-studio"] && !Shopify.designMode) return;
  try {
    
(()=>{
  class SunshineStudio {
    constructor(root){
      if(root.dataset.initialized)return;root.dataset.initialized='true';this.root=root;
      this.t=JSON.parse(root.parentElement.querySelector('[data-studio-translations]').textContent);
      this.q=s=>root.querySelector(s);this.qa=s=>[...root.querySelectorAll(s)];
      this.demo=root.dataset.preview==='true';this.base=root.dataset.endpoint;this.assets=[];this.selected=null;this.reference=null;this.credits=3;this.busy=false;this.mode='idea';
      this.q('[data-preview-bar]').hidden=!this.demo;this.q('[data-gallery-count]').textContent=this.t.private_gallery;
      this.qa('[data-login-link]').forEach(a=>a.href=root.dataset.login);
      this.bind();void this.load();
    }
    status(message,error=false){this.q('[data-status]').textContent=message;this.q('[data-status]').dataset.error=String(error);}
    async api(path,options={}){
      const headers={'Accept':'application/json',...(this.session?.csrf?{'X-Studio-CSRF':this.session.csrf}:{}),...options.headers};
      const r=await fetch(this.base+path,{credentials:'same-origin',cache:'no-store',...options,headers});
      const data=await r.json();if(!r.ok){const e=Error(data.error||this.t.connection_error);e.status=r.status;throw e;}return data;
    }
    async load(){
      if(this.demo){this.session={credits:3,generationEnabled:true,paymentsEnabled:true};this.updateBalance();return;}
      try{
        this.session=await this.api('/session');this.authRequired=false;this.status('');this.credits=this.session.credits;this.assets=this.session.assets;this.renderGallery();this.updateBalance();
        this.q('[data-gate]').hidden=true;this.q('[data-login-link]').textContent=this.t.studio_account;
        if(!this.selected&&this.assets.length)this.select(this.assets[0]);
        if(this.session.coupon){this.q('[data-coupon]').hidden=false;this.q('[data-coupon]').textContent=this.t.coupon_message.replace('{code}',this.session.coupon);}
        if(!this.session.generationEnabled)this.status(this.t.unavailable);
        const pending=this.session.jobs?.[0];if(pending&&!this.polling)void this.poll(pending.id);
      }catch(e){this.session=null;this.authRequired=e.status===401||e.status===403;if(this.authRequired)this.requireLogin();else this.status(this.t.connection_error,true);}
    }
    requireLogin(){this.q('[data-gate]').hidden=false;this.status(this.q('[data-gate] p').textContent.trim());}
    updateBalance(){this.q('[data-balance]').textContent=Math.max(0,this.credits);}
    lock(value){this.busy=value;this.qa('[data-generate], [data-upload], [data-file], [data-consent], [data-mode], [data-revise], [data-clear-reference]').forEach(el=>el.disabled=value);this.q('[data-room]').classList.toggle('is-loading',value);this.q('[data-generate-label]').textContent=value?this.t.working_label:this.t.create_art;}
    setMode(mode){this.mode=mode;this.qa('[data-mode]').forEach(b=>{b.classList.toggle('is-active',b.dataset.mode===mode);b.setAttribute('aria-pressed',String(b.dataset.mode===mode));});this.q('[data-upload-panel]').hidden=mode!=='photo';}
    bind(){
      this.qa('[data-mode]').forEach(b=>b.addEventListener('click',()=>this.setMode(b.dataset.mode)));
      this.qa('[data-example]').forEach(b=>b.addEventListener('click',()=>{this.q('[data-prompt]').value=this.t['example_'+b.dataset.example];this.q('[data-prompt]').focus();}));
      this.q('[data-file]').addEventListener('change',()=>{
        if(this.busy)return;
        const file=this.q('[data-file]').files[0];if(!file)return;
        this.file=null;this.reference=null;this.q('[data-reference]').hidden=true;this.q('[data-local-photo]').hidden=true;this.q('[data-consent]').checked=false;this.setMode('photo');
        if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>10*1024*1024){this.status(this.t.photo_too_large,true);this.file=null;return;}
        this.file=file;if(this.localURL)URL.revokeObjectURL(this.localURL);this.localURL=URL.createObjectURL(file);
        this.q('[data-local-photo]').hidden=false;this.q('[data-local-photo] img').src=this.localURL;this.q('[data-filename]').textContent=file.name;
        this.status(this.t.photo_selected);
      });
      this.q('[data-upload]').addEventListener('click',()=>void this.upload());
      this.q('[data-clear-reference]').addEventListener('click',()=>void this.clearReference());
      this.q('[data-generate]').addEventListener('click',()=>void this.generate());
      this.q('[data-revise]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        this.setReference(this.selected);this.setMode('idea');this.q('[data-prompt]').value='';this.q('[data-prompt]').placeholder=this.t.change_placeholder;this.q('[data-prompt]').focus();this.status(this.t.refine_ready);
      });
      this.q('[data-buy-credits]').addEventListener('click',()=>void this.checkout('credits'));
      this.q('[data-download]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.selected.download&&!this.demo){location.assign(this.base+'/assets/'+this.selected.id+'/download');return;}
        void this.checkout('digital');
      });
      this.q('[data-canvas]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.demo)return this.status(this.t.sample_canvas);
        const url=new URL('/products/canvas-photo-editor',location.origin);url.searchParams.set('view','sunshine-ai-builder');url.searchParams.set('studio_artwork',this.selected.id);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        location.assign(url.href);
      });
      document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'&&!this.demo&&!this.busy)void this.load();});
    }
    async human(action){
      if(this.demo)return 'preview';
      if(!this.session?.turnstileSiteKey)throw Error(this.t.unavailable);
      if(!window.turnstile){
        await new Promise((resolve,reject)=>{
          let script=document.querySelector('script[data-sc-turnstile]');
          if(!script){script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.dataset.scTurnstile='true';script.async=true;document.head.append(script);}
          script.addEventListener('load',resolve,{once:true});script.addEventListener('error',()=>reject(Error(this.t.human_failed)),{once:true});
        });
      }
      if(this.widget!==undefined)window.turnstile.remove(this.widget);
      this.status(this.t.human_wait);
      return new Promise((resolve,reject)=>{
        this.widget=window.turnstile.render(this.q('[data-human]'),{sitekey:this.session.turnstileSiteKey,action,theme:'light',callback:resolve,'error-callback':()=>reject(Error(this.t.human_failed)),'expired-callback':()=>reject(Error(this.t.human_failed))});
      });
    }
    resetPhotoSelection(){this.file=null;this.q('[data-file]').value='';this.q('[data-local-photo]').hidden=true;}
    setReference(asset){this.resetPhotoSelection();this.reference=asset;this.q('[data-reference]').hidden=false;this.q('[data-reference] img').src=asset.preview;}
    async clearReference(){
      if(this.busy)return;
      try{if(this.reference?.kind==='upload'&&!this.demo)await this.api('/assets/'+this.reference.id,{method:'DELETE'});
        this.reference=null;this.resetPhotoSelection();this.setMode('idea');this.q('[data-reference]').hidden=true;this.status(this.t.removed);
      }catch(e){this.status(e.message,true);}
    }
    async preparePhoto(){
      if(!this.file){if(this.mode==='photo'&&!this.reference)throw Error(this.t.photo_choose_first);return;}
      if(!this.q('[data-consent]').checked)throw Error(this.t.photo_choose_first);
      const file=this.file,token=await this.human('upload');this.status(this.t.uploading);
      const asset=this.demo?{id:'sample-upload',kind:'upload',preview:this.localURL}:await this.api('/upload',{method:'POST',headers:{'Content-Type':file.type,'X-Turnstile-Token':token},body:file});
      if(!asset?.id)throw Error(this.t.connection_error);
      this.setReference(asset);this.setMode('idea');this.status(this.t.photo_ready);this.q('[data-prompt]').placeholder=this.t.change_placeholder;
    }
    async upload(){
      if(this.busy)return;if(!this.file)return this.status(this.t.photo_choose_first,true);
      this.lock(true);
      try{await this.preparePhoto();this.q('[data-prompt]').focus();}catch(e){this.status(e.message,true);}finally{this.lock(false);}
    }
    async generate(){
      if(this.busy)return;
      if(!this.demo&&this.authRequired)return this.requireLogin();
      if(!this.demo&&!this.session?.generationEnabled)return this.status(this.t.unavailable,true);
      if(this.credits<=0)return this.status(this.t.credits_empty,true);
      const prompt=this.q('[data-prompt]').value.trim();if(prompt.length<3)return this.status(this.t.prompt_required,true);
      this.lock(true);
      try{
        await this.preparePhoto();
        const token=await this.human('generate'),style=this.q('[data-style]').value;
        if(this.demo){
          const asset={id:crypto.randomUUID(),kind:'generated',preview:this.q('[data-art]').dataset.sample||this.q('[data-art]').src,width:1024,height:1024,created:Date.now(),download:false};
          this.assets.unshift(asset);this.credits--;this.updateBalance();this.select(asset);this.renderGallery();this.status(this.t.sample_status);return;
        }
        const body={prompt:prompt+(style==='none'?'':'\n'+this.t['style_prompt_'+style]),size:this.q('[data-size]').value,referenceId:this.reference?.id,requestId:crypto.randomUUID(),turnstileToken:token};
        const job=await this.api('/generate',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
        this.credits--;this.updateBalance();await this.poll(job.id);
      }catch(e){this.status(e.message,true);}finally{this.lock(false);}
    }
    async poll(id){
      if(this.polling)return;this.polling=true;this.lock(true);this.status(this.t.creating);
      try{
        for(let attempt=0;attempt<100;attempt++){
          const job=await this.api('/jobs/'+id);
          if(job.status==='complete'){
            const asset=await this.api('/assets/'+job.asset);this.assets=this.assets.filter(a=>a.id!==asset.id);this.assets.unshift(asset);this.select(asset);this.renderGallery();this.status(this.t.created);return;
          }
          if(job.status==='failed'){this.credits++;this.updateBalance();throw Error(job.error);}
          await new Promise(r=>setTimeout(r,3000));
        }
        this.status(this.t.creating);
      }catch(e){this.status(e.message,true);}finally{this.polling=false;this.lock(false);}
    }
    select(asset){
      this.selected=asset;this.q('[data-art]').src=asset.preview;this.q('[data-art]').alt=this.t.artwork_preview;
      this.q('[data-dimensions]').textContent=`${asset.width} × ${asset.height} px · ${this.t.original_pixels}`;
      this.q('[data-preview-label]').textContent=this.demo?this.t.sample:this.t.artwork_label;
      this.q('[data-download]').textContent=asset.download?this.t.download_owned:this.t.buy_download;
      this.q('.sc-art-frame').style.aspectRatio=String(asset.width/asset.height);
      this.qa('[data-gallery] button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.id===asset.id)));
    }
    renderGallery(){
      const gallery=this.q('[data-gallery]');if(!this.assets.length)return;gallery.replaceChildren();
      this.assets.forEach((asset,index)=>{
        const button=document.createElement('button');button.type='button';button.dataset.id=asset.id;button.setAttribute('aria-pressed',String(asset.id===this.selected?.id));
        button.setAttribute('aria-label',`${this.t.artwork_label} ${this.assets.length-index}`);
        const img=document.createElement('img');img.src=asset.preview;img.alt='';img.width=104;img.height=90;img.loading='lazy';
        const label=document.createElement('small');label.textContent=`${this.t.artwork_label} ${this.assets.length-index}`;
        button.append(img,label);button.addEventListener('click',()=>this.select(asset));gallery.append(button);
      });
      this.q('[data-gallery-count]').textContent=`${this.assets.length} ${this.t.saved}`;
    }
    async checkout(kind){
      if(this.demo)return this.status(this.t.sample_purchase);
      if(this.authRequired)return this.requireLogin();
      if(!this.session?.paymentsEnabled)return this.status(this.t.unavailable,true);
      if(kind==='digital'&&!this.selected)return this.status(this.t.choose_artwork,true);
      try{this.status(this.t.checkout_opening);const result=await this.api('/checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({kind,assetId:kind==='digital'?this.selected.id:undefined})});
        this.status(this.t.return_note);location.assign(result.url);
      }catch(e){this.status(e.message,true);}
    }
  }
  const boot=()=>document.querySelectorAll('.sc-studio').forEach(root=>new SunshineStudio(root));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();


  } catch(e) { console.error(e); }
})();
})();
